module.exports = __webpack_public_path__ + "assets/img/794f72a22443f7a3b2f1d19eb2d4146e.png";